export function initSelect2(selector, options = {}) {
  const $ = window.jQuery
  if (!$ || !$.fn.select2) {
    setTimeout(() => this.initSelect2(selector, options), 100)
    return
  }
  const defaults = {
    placeholder: "Select...",
    allowClear: false,
    width: "100%",
  }
  const opts = { ...defaults, ...options }
  $(selector).each((_, el) => {
    const $el = $(el)
    if ($el.data("select2")) $el.select2("destroy")
    $el.select2(opts)
  })
}